export const getRandomValue = items => {
  const random = (mn, mx) => Math.random() * (mx - mn) + mn;
  return items[Math.floor(random(1, items?.length + 1)) - 1];
};
